// ABOUTME: One user's inclusive day range — the unit the realtime invalidation and the coach
// ABOUTME: screen's chunk refetch reason about.

/** Inclusive `yyyy-MM-dd` range of one user's days an event says changed. */
export interface CalendarRange {
  userId: string
  from: string
  to: string
}

/** Whether the range touches the inclusive days `from`..`to` (ISO dates compare as strings). */
export const overlapsDays = (range: { from: string; to: string }, from: string, to: string): boolean =>
  range.from <= to && range.to >= from

/**
 * The inclusive bounds of a day list, or undefined when it holds none. One
 * definition: every caller that turns days into a range needs the same answer,
 * and a `reduce` with no seed throws on the empty list.
 */
export const dayBounds = (days: readonly string[]): { from: string; to: string } | undefined =>
  days.length === 0
    ? undefined
    : {
        from: days.reduce((earliest, day) => (day < earliest ? day : earliest)),
        to: days.reduce((latest, day) => (day > latest ? day : latest)),
      }
